import * as React from 'react';
import { Form, Segment, Label, Tab } from 'semantic-ui-react';
import '../../panels/panels.css';
import { default as Renderers } from '../../sys/columns';
import ReactTable from 'react-table';
import CustomPagination from '../../sys/pagination';
import * as ReactTooltip from 'react-tooltip';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import ManifestView from '../manifest';
import MIMEHeaderView from '../mimeHeader';
import MediaFileView from '../media-file-stats';
import TextView from '../textTracks';
import AlarmLogView from '../logs/alarmlog';
import TransactionLogView from '../logs/transactionlog';

const _ = require('lodash');

class State {
    alarmLogData ?: any;
    txnLogData ?: any;
    tabIndex ?: number;
    stream: any;
    showTabs: boolean;
}

interface Props {
    streamId: number;
    streamName: string;
    streamResult: string;
    streamMessage: string;
    url?: string;
    vod?: boolean;
    sharedManifest ?: boolean;
    streamType ?: string;
    masterFile ?: boolean;
    header ?: boolean;
    mode?: string;
    audioEnabled ?: boolean;
    videoEnabled ?: boolean;
    pixelEnabled ?: boolean;
}

export default class TestDetailsView extends React.Component<Props, State> {
    public static defaultProps: Partial<Props> = {
        streamId: 0,
        streamName: '',
        streamResult: '',
        streamMessage: '',
        url: '',
        vod: false,
        sharedManifest: false,
        streamType: '',
        masterFile: false,
        header: true,
        mode: 'VOD',
        audioEnabled: false,
        videoEnabled: false,
        pixelEnabled: false
    };

    protected alarmColumnsErrors = [
        {
            Header: 'Alarm Time',
            accessor: 'timestamp',
            width: 150,
            headerStyle: { textAlign: 'left' },
            Cell: (props: any) => Renderers.timestamp.format(props.value),
        }, {
            Header: 'Close Time',
            accessor: 'closeTimestamp',
            headerStyle: { textAlign: 'left' },
            width: 150,
            Cell: (props: any) => Renderers.timestamp.format(props.value),
        }, {
            Header: 'Alarm Name',
            accessor: 'mnemonic',
            width: 220,
            headerStyle: {textAlign: 'left'},
            Cell: (props: any) => this.alarmNameRenderer(props)
        }, {
            Header: 'File Name',
            accessor: 'file',
            width: 250,
            headerStyle: { textAlign: 'left' }
        }, {
            Header: 'Information',
            accessor: 'information',
            headerStyle: { textAlign: 'left' },
            width: 800
        }];

    protected alarmColumns = [
        {
            Header: 'Alarm Time',
            accessor: 'timestamp',
            width: 180,
            headerStyle: { textAlign: 'left' },
            aggregate: (values: any, row: any) => (values.length > 0) ? { min: _.min(values), max: _.max(values) } : null,
            Cell: (props: any) => Renderers.timestamp.format(props.value),
            Aggregated: (row: any) => (
                <span className="aggregated-timestamp">
                        {Renderers.timestamp.format(row.value.min)} to {Renderers.timestamp.format(row.value.max)}
                    </span>
            )
        }, {
            Header: 'Alarm',
            accessor: 'alarmName',
            width: 220,
            headerStyle: { textAlign: 'left' },
            Cell: (props: any) => this.alarmNameRenderer(props),
        }, {
            Header: 'Level',
            accessor: 'severity',
            width: 150,
            headerStyle: { textAlign: 'left' },
            Cell: (props: any) => this.severityRenderer(props)
        }, {
            Header: 'Object',
            accessor: 'detail.name',
            headerStyle: { textAlign: 'left' },
            width: 300,
            Cell: (props: any) => this.nameRenderer(props.value),
            Aggregated: (row: any) => { return null; }
        }, {
            Header: 'Type',
            accessor: 'detail.streamType',
            headerStyle: { textAlign: 'left' },
            width: 200,
            resizable: false,
            Cell: (props: any) => Renderers.streamType(props.value),
            Aggregated: (row: any) => null
        }, {
            Header: 'Host',
            accessor: 'detail.url',
            headerStyle: { textAlign: 'left' },
            width: 240,
            resizable: false,
            Cell: (props: any) => this.hostUrlRenderer(props.value),
            Aggregated: (row: any) => null
        }, {
            Header: 'Media IP Address',
            accessor: 'detail.mediaIp',
            headerStyle: { textAlign: 'left' },
            width: 240,
            Cell: (props: any) => this.mediaIpRenderer(props.value),
            Aggregated: (row: any) => { return null; }
        }];

    protected txnColumns = [
    {
        Header: 'Date/Time',
        accessor: 'timestamp',
        headerStyle: { textAlign: 'left' },
        width: 200,
        // resizable: false,
        aggregate: (values: any, row: any) => (values.length > 0) ? { min: _.min(values), max: _.max(values)  } : null,
        Cell: (props: any) => Renderers.timestamp.format(props.value),
        Aggregated: (row: any) => (
            <span className="aggregated-timestamp">
                        {Renderers.timestamp.brief(row.value.min)} to {Renderers.timestamp.brief(row.value.max)}
                    </span>
        )
    }, {
        Header: 'Entry Type',
        accessor: 'type',
        headerStyle: { textAlign: 'left' },
        width: 160,
        // resizable: false,
        aggregate: (values: any, row: any) => (values.length > 0) ? _.uniq(values) : null,
        Cell: (props: any) => this.eventRenderer(props),
    }, {
        Header: 'Stream Name',
        accessor: 'name',
        headerStyle: { textAlign: 'left' },
        width: 300,
        // resizable: false,
        Cell: (props: any) => this.nameRenderer(props.value),
        Aggregated: (row: any) => { return null; }
    }, {
        Header: 'Type',
        accessor: 'streamType',
        headerStyle: { textAlign: 'left' },
        width: 105,
        // resizable: false,
        Cell: (props: any) => Renderers.streamType(props.value),
        Aggregated: (row: any) => null
    }, {
        Header: 'Detail',
        accessor: 'detail',
        headerStyle: { textAlign: 'left' },
        width: 800,
        Cell: (props: any) => this.txnDetailRenderer(props.value),
        Aggregated: (row: any) => { return null; }
    }];

    private updateTimer: number;

    componentWillMount() {
        this.setState({
          alarmLogData: '',
          txnLogData: '',
          tabIndex: 0,
          stream: '',
          showTabs: false
        });
        this.fetchDataFromStorage();
        // this.fetchAlarmLogData(true, this.props.streamName);
        this.fetchTxnLogData(true, this.props.streamName);
        this.renderSummaryDetails = this.renderSummaryDetails.bind(this);
        this.renderMetricsDetails = this.renderMetricsDetails.bind(this);
        this.renderHeadersDetails = this.renderHeadersDetails.bind(this);
        this.renderPlaylistDetails = this.renderPlaylistDetails.bind(this);
        this.renderDownloadDetails = this.renderDownloadDetails.bind(this);
        this.renderAlarmLogDetails = this.renderAlarmLogDetails.bind(this);
        this.renderAlarmLogDetailsErrors = this.renderAlarmLogDetailsErrors.bind(this);
        this.renderAlarmLog = this.renderAlarmLog.bind(this);
        this.renderTxnLogDetails = this.renderTxnLogDetails.bind(this);
        this.renderTxnLog = this.renderTxnLog.bind(this);
    }

    componentWillUnmount() {
        if (this.updateTimer !== null)
            clearTimeout(this.updateTimer);
    }

    transformData(data: any) {
        let finalData: any;
        if (data.results) {
            data = data.results.vod;
            finalData = [];
        }

        // console.log (data);
        if (Array.isArray(data)) {
            data.forEach((session: any) => {
                let streams = [];
                if (session.variants) {
                    streams.push({
                     ...session,
                     master: true
                    });
                } else {
                    streams.push({
                     ...session,
                     master: false
                    });
                }

                streams.forEach((stream: any) => {
                    finalData.push({
                       stream
                    });
                });
            });
            return finalData;
        }
        return data;
    }

    // SAN-4903
    fetchDataFromStorage() {
        let _this = this;
        let vodResults;
        if (window.localStorage && (vodResults = window.localStorage.getItem('vodResults'))) {
            let singleStream = JSON.parse(vodResults);
            if (singleStream !== null) {
                _this.setState({
                  stream: singleStream.stream,
                  alarmLogData: singleStream.stream.errors, // SAN-4923
                  showTabs: true
                });
            }
        }
    }

    fetchSingleStreamData(stream: any) {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/analytics';
        axios.post(url, {
            'aliases': 'name',
            'name': stream,
            'timerange': '100 to current',
            'namespace': 'api.surveyor.abr',
            'metrics': ['vod']
        })
            .then(function (response: AxiosResponse) {
                if (response.data.results) {
                    let singleStream = __this.transformData(response.data);
                    if (singleStream.length > 0) {
                        __this.setState({
                            stream: singleStream,
                            showTabs: true
                        });
                    }
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchSingleStreamData() error: ', error);
                //    __this.scheduleNextUpdate();
            });
    }

    formatMode(str: string) {
        // FILE:ALL TIME:NORMAL REQ:GET
        let index = 0; let subStr1 = ''; let subStr2 = ''; let strVar = '';
        var array = str.split(' ');
        for (let i = 0; i < array.length; i++) {
            index = array[i].indexOf(':');
            if (index > 0) {
                subStr1 = array[i].substr(0, index + 2);
                subStr2 = array[i].substr(index + 2);
                if (!array[i].startsWith('REQ')) {
                    subStr2 = subStr2.toLowerCase();
                    strVar += subStr1 + subStr2 + ', ';
                } else {
                    strVar += subStr1 + subStr2;
                }
            }
        }
        return strVar;
    }

    renderDLSizeMB(manifestBytes: number) {
        let totalBytes = manifestBytes;
        let master = this.state.stream ? this.state.stream.master : false;

        if (master) {
            if (this.state.stream && this.state.stream.variants) {
                for (let i = 0; i < this.state.stream.variants.length; i++) {
                    totalBytes += this.state.stream.variants[i].statistics.files.manifest.bytes;
                    totalBytes += this.state.stream.variants[i].statistics.files.media.totalBytes;
                }
            }
        } else {
            if (this.state.stream && this.state.stream.statistics) {
                totalBytes += this.state.stream.statistics.files.manifest.bytes;
                totalBytes += this.state.stream.statistics.files.media.totalBytes;
            }
        }

        return Renderers.bytesToKB2(totalBytes);
    }

    renderUrl(value: any): React.ReactNode {
        // let url = value.length > 55 ? value.substring(0, 52) + '...' : value;

        return (
            <div className="word-wrap" data-tip={value}>
                {value}
            </div>
        );
    }

    renderContentAnalysis() {
       let message = 'Content Analysis is not enabled.'; // false & false

       if (this.state.stream.master) {
            message = '-';
       } else if (this.state.stream.statistics.qoe.videoActive === true && this.state.stream.statistics.qoe.audioActive === true) {
           message = 'Video & Audio';
       } else if (this.state.stream.statistics.qoe.videoActive === true && this.state.stream.statistics.qoe.audioActive === false) {
           message = 'Video';
       } else if (this.state.stream.statistics.qoe.videoActive === false && this.state.stream.statistics.qoe.audioActive === true) {
           message = 'Audio';
       }
       return message;
    }

    parseMode(portion: number) {
        let idx = 0; let retValue = '';
        let subStr1 = ''; let subStr2 = '';

        // "FILE:ALL TIME:NORMAL REQ:GET "
        // "FILE:PARTIAL BLOCKS TIME:NORMAL REQ:GET "

        var array = this.state.stream.statistics.summary.mode.split(' ');
        if (portion !== 0 && array.length === 5) portion++;
        idx = array[portion].indexOf(':');
        if (idx > 0) {
            subStr1 = array[portion].substr(idx + 1, 1);
            subStr2 = array[portion].substr(idx + 2);
            subStr2 = subStr2.toLowerCase();
            retValue = subStr1 + subStr2;
            if (portion === 0) {
                if (retValue === 'Partial') {
                    retValue = retValue + ' ' + 'Blocks';
                }
            }
        }
        return retValue;
    }

    renderSummaryDetails() {
        return (
            <div>
                <React.Fragment>
                    <Form>
                        <div className="spacerFS"/>
                        <fieldset id="fieldSetX" className="field-set list1">
                            <legend>Test Details</legend>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    Status
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.stateRenderer(this.props.streamResult)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    Start Time
                                </Label>
                                <Label className="left-align-label-list">
                                    {Renderers.timestamp.calendar(this.state.stream.statistics.summary.startTime)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    End Time
                                </Label>
                                <Label className="left-align-label-list">
                                    {Renderers.timestamp.calendar(this.state.stream.statistics.summary.stopTime)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    Duration
                                </Label>
                                <Label className="left-align-label-list">
                                    {Renderers.timestamp.duration(this.state.stream.statistics.summary.stopTime - this.state.stream.statistics.summary.startTime)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    File Mode
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.parseMode(0)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    Speed
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.parseMode(1)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    Validation
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.parseMode(2) === 'Get' ? 'Full Media' : 'Header Only'}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    Alarm Template
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.state.stream.statistics.summary.template}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    Download Size
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.renderDLSizeMB(0)} {'KBytes'}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list1">
                                    Media Segments Downloaded
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.commaRenderer(this.state.stream.statistics.files.media.download.rate.samples)}
                                </Label>
                            </Form.Group>
                        </fieldset>
                        <fieldset id="fieldSetY" className="field-set list2">
                            <legend>ABR Details</legend>
                            <Form.Group grouped>
                                <Label className="right-align-label-list2">
                                    Format
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.streamTypeRenderer(this.state.stream.streamType)}
                                </Label>
                            </Form.Group>
                            {/*<Form.Group grouped>*/}
                            {/*    <Label className="right-align-label-list2">*/}
                            {/*        Type*/}
                            {/*    </Label>*/}
                            {/*    <Label className="left-align-label-list">*/}
                            {/*        {'?'}*/}
                            {/*        /!*{this.state.stream.statistics.mediaAttributes.codecs}*!/*/}
                            {/*    </Label>*/}
                            {/*</Form.Group>*/}
                            <Form.Group grouped>
                                <Label className="right-align-label-list2">
                                    Bitrate (Bytes)
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.commaRenderer(this.state.stream.statistics.summary.bandwidth)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list2">
                                    Resolution
                                </Label>
                                <Label className="left-align-label-list">
                                    {/* tslint:disable-next-line:max-line-length */}
                                    {this.renderResolution()}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list2">
                                    URL
                                </Label>
                                <Label className="left-align-label-list2">
                                    {this.renderUrl(this.state.stream.statistics.summary.url)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list2">
                                    Total Media Segments
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.commaRenderer(this.state.stream.statistics.files.media.totalFiles)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list2">
                                    Total Duration
                                </Label>
                                <Label className="left-align-label-list">
                                    {Renderers.timestamp.duration(this.state.stream.statistics.vod.duration)}
                                </Label>
                            </Form.Group>
                        </fieldset>
                        <fieldset id="fieldSetZ" className="field-set list3">
                            <legend>Media Details {this.state.stream.master ? ' - *Not applicable for top-level streams.' : ''}</legend>
                            <Form.Group grouped>
                                <Label className="right-align-label-list3">
                                    Content Analysis
                                </Label>
                                <Label className="left-align-label-list2">
                                    {this.renderContentAnalysis()}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list3">
                                    Video Codec
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.checkTopLevelVideo(this.state.stream.statistics.mediaAttributes.video.codecType)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list3">
                                    Audio Codec
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.checkTopLevelAudio(this.state.stream.statistics.mediaAttributes.audio.codecType)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list3">
                                    Chroma Format
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.checkTopLevelVideo(this.state.stream.statistics.mediaAttributes.video.chromaFormat)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list3">
                                    Aspect Ratio
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.checkTopLevelVideo(this.state.stream.statistics.mediaAttributes.video.aspectRatio)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list3">
                                    Frame Rate
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.checkTopLevelVideo(this.state.stream.statistics.mediaAttributes.video.frameRate, true)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped>
                                <Label className="right-align-label-list3">
                                    Progressive
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.checkTopLevelVideo(this.state.stream.statistics.mediaAttributes.video.progressive === false ? 'False' : 'True')}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list3">
                                    Audio Sample Rate
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.checkTopLevelAudio(this.state.stream.statistics.mediaAttributes.audio.sampleRate)}
                                </Label>
                            </Form.Group>
                            <Form.Group grouped className="form-grouped">
                                <Label className="right-align-label-list3">
                                    Audio Channels
                                </Label>
                                <Label className="left-align-label-list">
                                    {this.checkTopLevelAudio(this.state.stream.statistics.mediaAttributes.audio.channels)}
                                </Label>
                            </Form.Group>
                        </fieldset>
                    </Form>
                </React.Fragment>
            </div>
        );
    }

    serverChangeRenderer(stream: any) {
        if (stream.statistics && stream.statistics.connection) {
            // tslint:disable-next-line:max-line-length
            return (stream.statistics.connection && stream.statistics.connection.manifest ? stream.statistics.connection.manifest.IPChanges + ' / ' + stream.statistics.connection.media.IPChanges : '');
        } else {
            return '';
        }
    }

    commonTimeRenderer(props: any, bitMap: any, index: number, columnId: string): React.ReactNode {
        let clsName = '';

        if (this.state.stream.statistics && this.state.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
        }

        return(
            <div className={clsName}>
                {(props / 1000).toFixed(3)}
            </div>
        );
    }

    getAlarmHighlight(stream: any, bitMap: any, index: number) {
        let clsName = '';
        if (!(stream.statistics)) {
            return clsName;
        }
        let activeAlarmField = stream.statistics.summary.errors.active[index];
        let monitoredAlarmField = stream.statistics.summary.errors.mask[index];
        let historyAlarmField = stream.statistics.summary.errors.bin[index];

        // tslint:disable-next-line:no-bitwise
        if ((monitoredAlarmField & bitMap) !== 0) {
            // tslint:disable-next-line:no-bitwise
            if ((activeAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-critical';
                // tslint:disable-next-line:no-bitwise
            } else if ((historyAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-minr';
            } else {
                clsName = 'iq-td-status-clear';
            }
        } else {
            // tslint:disable-next-line:no-bitwise
            if ((historyAlarmField & bitMap) !== 0) {
                clsName = 'iq-td-alarm-minr';
            } else {
                clsName = '';
            }
        }

        return clsName;
    }

    commonAlarm0Renderer(props: any, bitMap: any, index: number, columnId: string): React.ReactNode {
        let clsName = '';
        let value = props;

        if (this.state.stream.statistics && this.state.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
        }

        if (value === undefined)
            value = '0';

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }

    commonAlarmRenderer(props: any, bitMap: any, index: number, columnId: string) {
        let clsName = '';
        let value = props;

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (this.state.stream.statistics && this.state.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
        }

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }
    commaSeparated(value: any): React.ReactNode {
        let parts = value.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return <span  className="right-aligned">{parts.join('.')}</span>;
    }
    httpCodesRenderer(value: any) {
        if (value === null || value === undefined) {
            return (
                <div>
                    <div className="http totals">
                        <div className="http2xxBox-empty">-</div>
                        <div className="http3xxBox-empty">-</div>
                        <div className="http4xxBox-empty">-</div>
                        <div className="http5xxBox-empty">-</div>
                        <div className="outline" data-tip="close">-</div>
                        <div className="outline" data-tip="socket and other">-</div>
                    </div>
                </div>);
        } else {
            return (
                <div
                    className="http totals"
                    title="2xx, 3xx, 4xx, 5xx http error counts, close errors and socket errors"
                >
                    <div className={(value.hss2xx === 0 || value.hss2xx === undefined) ? 'http2xxBox-empty' : 'http2xxBox'} title="2xx">{(value.hss2xx === 0 || value.hss2xx === undefined) ? '-' : this.commaSeparated(value.hss2xx)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsr3xxTotal === 0 || value.hsr3xxTotal === undefined) ? 'http3xxBox-empty' : 'http3xxBox'} title="3xx">{(value.hsr3xxTotal === 0 || value.hsr3xxTotal === undefined) ? '-' : this.commaSeparated(value.hsr3xxTotal)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsce4xxTotal === 0 || value.hsce4xxTotal === undefined) ? 'http4xxBox-empty' : 'http4xxBox'} title="4xx">{(value.hsce4xxTotal === 0 || value.hsce4xxTotal === undefined) ? '-' : this.commaSeparated(value.hsce4xxTotal)}</div>
                    {/* tslint:disable-next-line:max-line-length */}
                    <div className={(value.hsse5xxTotal === 0 || value.hsse5xxTotal === undefined) ? 'http5xxBox-empty' : 'http5xxBox'} title="5xx">{(value.hsse5xxTotal === 0 || value.hsse5xxTotal === undefined) ? '-' : this.commaSeparated(value.hsse5xxTotal)}</div>
                    <div className="http-close outline" title="close">{(value.close === 0 || value.close === undefined) ? '-' : this.commaSeparated(value.close)}</div>
                    <div className="http-other outline" title="socket and other">{(value.socketErrors === 0 || value.socketErrors === undefined) ? '-' : this.commaSeparated(value.socketErrors)}</div>
                </div>
            );
        }
    }

    streamTypeRenderer(props: any): React.ReactNode  {
        let name = props;
        if (name.startsWith('HLS')) {
            name = 'Apple HLS';
        } else if (name.startsWith('HDS')) {
            name = 'Adobe HDS';
        } else if (name.startsWith('DASH')) {
            name = 'MPEG DASH';
        } else if (name.startsWith('HSS')) {
            name = 'Microsoft Smooth Streaming';
        }

        return (
            <div>{name}</div>
        );
    }

    passFailRenderer(props: any, error: string): React.ReactNode {
        let value; let errorArray; let errorFound = false;
        let master = this.state.stream ? this.state.stream.master : false;
        let failed = false;

        if (master) {
            value = this.state.stream.statistics.summary.result;
        } else {
            value = this.state.stream.statistics.summary.assetResult;
        }

        if (!(value === 'PASS')) {
            if (Array.isArray(props.value)) {
                errorArray = this.state.stream.statistics.summary.errors.binMnemArray;
                errorFound = errorArray.find((str: any) => str === error);
            } else {
                failed = props.value;
            }
        }

        if (!(errorFound || failed)) {
            return (
                <div>Pass</div>
            );
        } else {
            return (
                <div data-tip={error} className="label-red">
                    Fail
                    {this.tooltipRenderer()}
                </div>
            );
        }
    }

    checkVariant(props: any, bitMap: any, index: number, columnId: string): React.ReactNode  {
        let value = '-';
        let clsName = '';

        if (this.state.stream.master) {
            if (this.state.stream.statistics && this.state.stream.statistics.summary) {
                clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
            }
        }

        if (this.state.stream.master) {
            value =  this.state.stream.statistics.files && this.state.stream.statistics.files.manifest ? this.state.stream.statistics.files.manifest.varReqErr : '-';
        }

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }

    checkMaster(props: any, bitMap: any, index: number, columnId: string): React.ReactNode  {
        let clsName = '';
        let value;

        if (columnId === 'derivedVariantStartTime') {
            value = Renderers.secToMsec2(props);
        } else {
            value = props;
        }

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (this.state.stream.statistics && this.state.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
        }

        if (columnId === 'derivedVariantStartTimeExceeded' && (props.original.stream.status && props.original.stream.status.monitorMode && props.original.stream.status.monitorMode === 'Header Only')) {
            value = '-'; clsName = '';
        }

        if (this.state.stream.master) {
            value = '-'; clsName = '';
        }

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }

    checkNotMaster(props: any, bitMap: any, index: number, columnId: string): React.ReactNode {
        let clsName = '';
        let value = props;

        if (!this.state.stream.master) {
            value = '-'; clsName = '';
        } else {
            if (this.state.stream.statistics && this.state.stream.statistics.summary) {
                clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
            }
        }

        if (value === undefined)
            value = '0';

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }

    checkTopLevelVideo(props: any, isFrameRate?: boolean) {
        let value = props;

        if (this.state.stream.master || this.state.stream.statistics.qoe.videoActive === false) {
            value = '-';
        } else if (isFrameRate === true) {
            value = value.toFixed(2);
        }

        return(
            <div>
                {value}
            </div>
        );
    }

    renderResolution() {
        let value = '';

        if (this.state.stream.master || this.state.stream.statistics.qoe.videoActive === false) {
            value = '-';
        } else if (this.state.stream.statistics.mediaAttributes.video.horizontalSize === 0) {
            value = 'Unknown';
        } else {
            value = this.state.stream.statistics.mediaAttributes.video.horizontalSize + 'x' + this.state.stream.statistics.mediaAttributes.video.verticalSize;
        }

        return(
            <div>
                {value}
            </div>
        );
    }

    checkTopLevelAudio(props: any, isFrameRate?: boolean) {
        let value = props;

        if (this.state.stream.master || this.state.stream.statistics.qoe.audioActive === false) {
            value = '-';
        }

        return(
            <div>
                {value}
            </div>
        );
    }

    checkNA(props: any, bitMap: any, index: number, columnId: string): React.ReactNode  {

        let clsName = '';
        let value = props;

        if (this.state.stream.statistics && this.state.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
        }

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (this.state.stream.master)
            value = '-';
        if (props === 0)
            value = '-';

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }

    commaRenderer(props: any): React.ReactNode {
        let value = Renderers.commaSeparated2(props);
        if (this.state.stream.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    bytesToKbRenderer(props: any): React.ReactNode {
        let value = Renderers.bytesToKB2(props);
        if (this.state.stream.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    checkPixelMaster(value: any): React.ReactNode {
        if (this.state.stream.statistics.qoe.pixelActive === false)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    countAudioChannel(value: any, bitMap: any, index: number): React.ReactNode {
        // audioFL?: boolean;  // 0x01  = 1
        // audioFC?: boolean;  // 0x02  = 2
        // audioFR?: boolean;  // 0x04  = 4
        // audioRL?: boolean;  // 0x10  = 16
        // audioRR?: boolean;  // 0x20  = 32
        // audioLFE?: boolean; // 0x100 = 256 (311 total)

        let clsName = '';
        let audioString = '';

        switch (value) {
            case 0:
                audioString = '-';
                break;
            case 1:
                audioString = 'FL';
                break;
            case 2:
                audioString = 'FC';
                break;
            case 3:
                audioString = 'FL,FC';
                break;
            case 4:
                audioString = 'FR';
                break;
            case 5:
                audioString = 'FL,FR';
                break;
            case 6:
                audioString = 'FC,FR';
                break;
            case 7:
                audioString = 'FL,FC,FR';
                break;
            case 16:
                audioString = 'RL';
                break;
            case 17:
                audioString = 'FL,RL';
                break;
            case 18:
                audioString = 'FC,RL';
                break;
            case 19:
                audioString = 'FL,FC,RL';
                break;
            case 20:
                audioString = 'FR,RL';
                break;
            case 21:
                audioString = 'FL,FR,RL';
                break;
            case 22:
                audioString = 'FC,FR,RL';
                break;
            case 23:
                audioString = 'FL,FC,FR,RL';
                break;
            case 32:
                audioString = 'RR';
                break;
            case 33:
                audioString = 'FL,RR';
                break;
            case 34:
                audioString = 'FC,RR';
                break;
            case 35:
                audioString = 'FL,FC,RR';
                break;
            case 36:
                audioString = 'FR,RR';
                break;
            case 37:
                audioString = 'FL,FR,RR';
                break;
            case 38:
                audioString = 'FC,FR,RR';
                break;
            case 39:
                audioString = 'FL,FC,FR,RR';
                break;
            case 48:
                audioString = 'RL,RR';
                break;
            case 49:
                audioString = 'FL,RL,RR';
                break;
            case 50:
                audioString = 'FC,RL,RR';
                break;
            case 51:
                audioString = 'FL,FC,RL,RR';
                break;
            case 52:
                audioString = 'FR,RL,RR';
                break;
            case 53:
                audioString = 'FL,FR,RL,RR';
                break;
            case 54:
                audioString = 'FC,FR,RL,RR';
                break;
            case 55:
                audioString = 'FL,FC,FR,RL,RR';
                break;
            case 256:
                audioString = 'LFE';
                break;
            case 257:
                audioString = 'FL,LFE';
                break;
            case 258:
                audioString = 'FC,LFE';
                break;
            case 259:
                audioString = 'FL,FC,LFE';
                break;
            case 260:
                audioString = 'FR,LFE';
                break;
            case 261:
                audioString = 'FL,FR,LFE';
                break;
            case 262:
                audioString = 'FC,FR,LFE';
                break;
            case 263:
                audioString = 'FL,FC,FR,LFE';
                break;
            case 272:
                audioString = 'RL,LFE';
                break;
            case 273:
                audioString = 'FL,RL,LFE';
                break;
            case 274:
                audioString = 'FC,RL,LFE';
                break;
            case 275:
                audioString = 'FL,FC,RL,LFE';
                break;
            case 276:
                audioString = 'FR,RL,LFE';
                break;
            case 277:
                audioString = 'FL,FR,RL,LFE';
                break;
            case 278:
                audioString = 'FC,FR,RL,LFE';
                break;
            case 279:
                audioString = 'FL,FC,FR,RL,LFE';
                break;
            case 288:
                audioString = 'RR,LFE';
                break;
            case 289:
                audioString = 'FL,RR,LFE';
                break;
            case 290:
                audioString = 'FC,RR,LFE';
                break;
            case 291:
                audioString = 'FL,FC,RR,LFE';
                break;
            case 292:
                audioString = 'FR,RR,LFE';
                break;
            case 293:
                audioString = 'FL,FR,RR,LFE';
                break;
            case 294:
                audioString = 'FC,FR,RR,LFE';
                break;
            case 295:
                audioString = 'FL,FC,FR,RR,LFE';
                break;
            case 304:
                audioString = 'RL,RR,LFE';
                break;
            case 305:
                audioString = 'FL,RL,RR,LFE';
                break;
            case 306:
                audioString = 'FC,RL,RR,LFE';
                break;
            case 307:
                audioString = 'FL,FC,RL,RR,LFE';
                break;
            case 308:
                audioString = 'FR,RL,RR,LFE';
                break;
            case 309:
                audioString = 'FL,FR,RL,RR,LFE';
                break;
            case 310:
                audioString = 'FC,FR,RL,RR,LFE';
                break;
            case 311:
                audioString = 'FL,FC,FR,RL,RR,LFE';
                break;
            default:
                audioString = '-';
                break;
        }
        if (this.state.stream.statistics && this.state.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
        }
        if (this.state.stream.statistics.qoe.audioEnabled === false) {
            value = '-'; clsName = '';
        } else if (this.state.stream.statistics.qoe.audioEnabled === true && this.state.stream.statistics.qoe.audioActive === false) {
            value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
        } else {
            value = audioString;
        }
        return (
            <div className={clsName}>
                {value}
            </div>
        );
    }

    checkQoEMedia(props: any, bitMap: any, index: number, columnId: string): React.ReactNode {
        let clsName = '';
        let value = props;

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (this.state.stream.statistics && this.state.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
        }

        if (this.state.stream.statistics && this.state.stream.statistics.qoe) {
            if (columnId === 'videoMosMin' || columnId === 'videoMosMax' || columnId === 'videoMosAvg') {
                if (this.state.stream.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (this.state.stream.statistics.qoe.videoEnabled === true && this.state.stream.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props === 0) {
                        value = props;
                    } else {
                        value = props.toFixed(2);
                    }
                }
            } else if (columnId === 'audioMosMin' || columnId === 'audioMosMax' || columnId === 'audioMosAvg') {
                if (this.state.stream.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (this.state.stream.statistics.qoe.audioEnabled === true && this.state.stream.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props === 0) {
                        value = props;
                    } else {
                        value = props.toFixed(2);
                    }
                }
            } else if (columnId === 'loudnessMin' || columnId === 'loudnessMax' || columnId === 'loudnessAvg') {
                if (this.state.stream.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (this.state.stream.statistics.qoe.audioEnabled === true && this.state.stream.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    if (props === undefined) {
                        value = 0;
                    } else {
                        if (props === 0) {
                            value = props;
                        } else {
                            value = props.toFixed(2);
                        }
                    }
                }
            } else if (columnId === 'silenceCh' || columnId === 'silenceChErr' || columnId === 'silenceErr') {
                if (this.state.stream.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (this.state.stream.statistics.qoe.audioEnabled === true && this.state.stream.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props;
                }
            } else if (columnId === 'loudnessDnDevMin' || columnId === 'loudnessDnDevMax' || columnId === 'loudnessDnDevAvg') {
                if (this.state.stream.statistics.qoe.audioEnabled === false) {
                    value = '-'; clsName = '';
                } else if (this.state.stream.statistics.qoe.audioEnabled === true && this.state.stream.statistics.qoe.audioActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props;
                }
            } else if (columnId === 'stillnessMin' || columnId === 'stillnessMax' || columnId === 'stillnessAvg') {
                if (this.state.stream.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (this.state.stream.statistics.qoe.videoEnabled === true && this.state.stream.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props;
                }
            } else if (columnId === 'pixelErr') {
                if (this.state.stream.statistics.qoe.pixelEnabled === false) {
                    value = '-';
                    clsName = '';
                } else if (this.state.stream.statistics.qoe.pixelEnabled === true && this.state.stream.statistics.qoe.pixelActive === false) {
                    value = 'Unsupported Codec';
                    clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props;
                }
            } else if (columnId === 'blacknessMin' || columnId === 'blacknessMax' || columnId === 'blacknessAvg') {
                if (this.state.stream.statistics.qoe.videoEnabled === false) {
                    value = '-'; clsName = '';
                } else if (this.state.stream.statistics.qoe.videoEnabled === true && this.state.stream.statistics.qoe.videoActive === false) {
                    value = 'Unsupported Codec'; clsName = 'iq-td-alarm-disabled';
                } else {
                    value = props;
                }
            }
        } else {
            value = '-'; clsName = '';
        }

        const inlineStyle = {
            paddingRight: '10px'
        };

        if (columnId === 'loudnessDnDevCurrent' && clsName !== 'iq-td-alarm-disabled') {
            return(
                <div className={clsName}>
                    <span style={inlineStyle}> {value} </span>
                </div>
            );
        } else {
            if (columnId === 'loudnessDnDevCurrent' && clsName === 'iq-td-alarm-disabled') {
                return(
                    <div className={clsName} data-tip="Unsupported Codec">
                        {this.tooltipRenderer()}
                        <span style={inlineStyle}> - </span>
                    </div>
                );
            } else {
                if (clsName === 'iq-td-alarm-disabled') {
                    return (
                        <div className={clsName} data-tip="Unsupported Codec">
                            {this.tooltipRenderer()}
                            -
                        </div>
                    );
                } else {
                    return (
                        <div className={clsName}>
                            {value}
                        </div>
                    );
                }
            }
        }
    }

    checkMediaType(props: any, bitMap: any, index: number, columnId: string): React.ReactNode {
        let clsName = '';
        let value = props.value;

        if (this.state.stream.statistics && this.state.stream.statistics.summary) {
            clsName = this.getAlarmHighlight(this.state.stream, bitMap, index);
        }

        if (value === '' || value === undefined) {
            value = 'missing';
            clsName = 'label-red';
        }

        if (this.state.stream.master || (!(props.original.stream.status && props.original.stream.status.media && props.original.stream.status.media.includes('text')))) {
            value =  '-'; clsName = '';
        }

        return(
            <div className={clsName}>
                {value}
            </div>
        );
    }

    renderBitrate(props: any): React.ReactNode {
        let value = Renderers.bytesToKB(props);
        if (this.state.stream.master)
            value =  '-';
        return (
            <div>{value}</div>
        );
    }

    renderMetricsDetails() {
        return (
            <div>
                <React.Fragment>
                    <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">Accessibility</Segment>
                        <Segment>
                            <Form>
                                {/*<Form.Group grouped>*/}
                                {/*    <Label className="right-align-label">*/}
                                {/*        Outage*/}
                                {/*    </Label>*/}
                                {/*</Form.Group>*/}
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Server Changes
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.serverChangeRenderer(this.state.stream)}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        DNS Time (ms)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonTimeRenderer(this.state.stream.statistics.connection.dns.time.current, 0x00000040, 0, 'dnsTime')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        DNS Query Failure
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarm0Renderer(this.state.stream.statistics.connection.dns.errors, 0x00200000, 0, 'dnsQueryFailure15M')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        TCP Connection Time (ms)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonTimeRenderer(this.state.stream.statistics.connection.time.current, 0x00000008, 0, 'tcpConnectionTime')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        TCP Connection Time Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarm0Renderer(this.state.stream.statistics.connection.timeErrors, 0x00000004, 0, 'tcpConnectionTime15M')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        TCP Connection Failure
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarmRenderer(this.state.stream.statistics.connection.errors, 0x08000000, 1, 'tcpConnectionFailure15M')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        HTTP Status Codes
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.httpCodesRenderer(this.state.stream.statistics.http)}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        HTTP 4xx Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarmRenderer(this.state.stream.statistics.http.hsce4xxTotal, 0x00080000, 0, 'http4XxError15M')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        HTTP 5xx Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarmRenderer(this.state.stream.statistics.http.hsse5xxTotal, 0x00020000, 0, 'http5XxError15M')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        MIME Header Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarmRenderer(this.state.stream.statistics.connection.mimeHeaderErrors, 0x00002000, 1, 'mimeHeaderErrors')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Expired Asset is Still Available
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.passFailRenderer(this.state.stream.statistics.vod.expirationErr, 'SYN-VOD-EXPIRATION-ERR')}
                                    </Label>
                                </Form.Group>
                            </Form>
                        </Segment>
                    </Segment.Group>
                    <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">ABR Protocol</Segment>
                        <Segment className="gray-background">
                            <Form>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Playlist Unavailable
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarmRenderer(this.state.stream.statistics.files.manifest.unaErr, 0x00000200, 1, 'playlistUnavailable')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Playlist File Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarmRenderer(this.state.stream.statistics.files.manifest.fileErr, 0x00200000, 1, 'playlistFileError')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Asset Type is not VOD
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.passFailRenderer(this.state.stream.statistics.vod.assetTypeErr, 'SYN-VOD-ASSETTYPE-ERR')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Variant Count Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarmRenderer(this.state.stream.statistics.files.manifest.profCntErr, 0x80000000, 1, 'variantCountError')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Variant Required Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkVariant(this.state.stream.statistics.files.manifest.varReqErr, 0x00000004, 1, 'variantRequiredError')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Media File Unavailable Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkMaster(this.state.stream.statistics.files.media.unaErr, 0x00000100, 1, 'mediaFileUnavailable')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Media File Duration Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkMaster(this.state.stream.statistics.files.media.durationMaxErrors, 0x00008000, 0, 'mediaFileDurationError15M')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Content Duration Longer than Defined
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.passFailRenderer(this.state.stream.statistics.vod.durationErr, 'SYN-VOD-DURATION-ERR')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Media File Bitrate Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkMaster(this.state.stream.statistics.files.media.bitrateErrors, 0x20000000, 1, 'mediaFileBitrateError15M')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Media File Timing Alignment
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkNotMaster(this.state.stream.statistics.files.media.mftaCntErr, 0x00010000, 0, 'mediaFileTimeNotAligned')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        I-Frame Missing
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkMaster(this.state.stream.statistics.qoe.errors.frameStartErr, 0x00000002, 0, 'iFrameMissing')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Audio Not Present
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkNA(this.state.stream.statistics.files.media.audio.NPErrors, 0x00000400, 0, 'audioNotPresent')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Video/Audio Sync Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkNA(this.state.stream.statistics.files.media.video.videoAudioSyncErrors, 0x00001000, 0, 'videoAudioSyncError')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Decryption Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkNA(this.state.stream.statistics.files.media.decrypt.errors, 0x00000800, 0, 'decryptionError')}
                                    </Label>
                                </Form.Group>
                            </Form>
                        </Segment>
                    </Segment.Group>
                    <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">Streaming Performance/Delivery</Segment>
                        <Segment className="gray-background">
                            <Form>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Media Segments Downloaded
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commaRenderer(this.state.stream.statistics.files.media.download.rate.samples)}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Total Kbytes Downloaded
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.bytesToKbRenderer(this.state.stream.statistics.files.media.totalBytes)}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Media Bitrate (Kbytes)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.bytesToKbRenderer(this.state.stream.statistics.files.media.bitrate.avg)}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Download Bitrate (Kbytes)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.bytesToKbRenderer(this.state.stream.statistics.files.media.download.rate.avg)}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Video Start Failure
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.commonAlarmRenderer(this.state.stream.statistics.timing.vsf, 0x02000000, 1, 'videoStartFailure')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Derived Variant Start Time (ms)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkMaster(this.state.stream.statistics.timing.dvst, 0x00800000, 1, 'derivedVariantStartTime')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Download Time Exceeded Total
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkMaster(this.state.stream.statistics.files.media.dltErr, 0x00004000, 0, 'downloadTimeExceededTotal')}
                                    </Label>
                                </Form.Group>
                            </Form>
                        </Segment>
                    </Segment.Group>
                    <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">Video On Demand Timeouts</Segment>
                        <Segment className="gray-background">
                            <Form>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Stream in Outage Longer than Timeout
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.passFailRenderer(this.state.stream.statistics.vod.timeoutTime, 'SYN-VOD-TIMEOUT-OUTAGE')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Stream Advance Test Exceeds Timeout
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.passFailRenderer(this.state.stream.statistics.vod.timeoutTime, 'SYN-VOD-TIMEOUT-ADVANCE')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Full Stream Test Exceeds Timeout
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.passFailRenderer(this.state.stream.statistics.vod.timeoutTime, 'SYN-VOD-TIMEOUT-FULLSTREAM')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Test Interrupted when Schedule Ended
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.passFailRenderer(this.state.stream.statistics.vod.timeoutTime, 'SYN-VOD-TIMEOUT-SCHEDULE')}
                                    </Label>
                                </Form.Group>
                            </Form>
                        </Segment>
                    </Segment.Group>
                    <Segment.Group className="system-config-segment">
                        <Segment className="segment-header">Media Quality</Segment>
                        <Segment className="gray-background">
                            <Form>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Video MOS (min/max/avg)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.mos.video.min, 0x00080000, 1, 'videoMosMin')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.mos.video.max, 0x00080000, 1, 'videoMosMax')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.mos.video.avg, 0x00080000, 1, 'videoMosAvg')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Black Screen (min/max/avg)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.gop.blackness.min, 0x00040000, 1, 'blacknessMin')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.gop.blackness.max, 0x00040000, 1, 'blacknessMax')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.gop.blackness.avg, 0x00040000, 1, 'blacknessAvg')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped>
                                    <Label className="right-align-label">
                                        Still Frame (min/max/avg)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.gop.stillness.min, 0x00020000, 1, 'stillnessMin')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.gop.stillness.max, 0x00020000, 1, 'stillnessMax')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.gop.stillness.avg, 0x00020000, 1, 'stillnessAvg')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Frame Error
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkPixelMaster(this.state.stream.statistics.qoe.errors.frameErr)}
                                        {/*{this.passFailRenderer(this.state.stream.statistics.qoe.errors.frameErr, 'SYN-FRAME-ERROR')}*/}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Pixel Block Artifact
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.pixel.pixelErr, 0x00100000, 1, 'pixelErr')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Audio MOS (min/max/avg)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.mos.audio.min, 0x00000002, 1, 'audioMosMin')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.mos.audio.max, 0x00000002, 1, 'audioMosMax')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.mos.audio.avg, 0x00000002, 1, 'audioMosAvg')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Loudness (min/max/avg)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.audio.loudness.min, 0x01000000, 1, 'loudnessMin')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.audio.loudness.max, 0x00400000, 1, 'loudnessMax')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.audio.loudness.avg, 0x01000000, 1, 'loudnessAvg')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Dialnorm Deviation (min/max/avg)
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.audio.loudnessDnDev.min, 0x00000001, 0, 'loudnessDnDevMin')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.audio.loudnessDnDev.max, 0x00000001, 0, 'loudnessDnDevMax')}
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.checkQoEMedia(this.state.stream.statistics.qoe.audio.loudnessDnDev.avg, 0x00000001, 0, 'loudnessDnDevAvg')}
                                    </Label>
                                </Form.Group>
                                <Form.Group grouped className="form-grouped">
                                    <Label className="right-align-label">
                                        Silence Channels
                                    </Label>
                                    <Label className="left-align-label-list">
                                        {this.countAudioChannel(this.state.stream.statistics.qoe.audio.silenceCh, 0x00000001, 1)}
                                    </Label>
                                    {/*<Label className="left-align-label-list">*/}
                                    {/*    {this.checkQoEMedia(this.state.stream.statistics.qoe.audio.silenceChErr, 0x00000001, 1, 'silenceChErr')}*/}
                                    {/*</Label>*/}
                                    {/*<Label className="left-align-label-list">*/}
                                    {/*    {this.checkQoEMedia(this.state.stream.statistics.qoe.audio.silenceErr, 0x00000001, 1, 'silenceErr')}*/}
                                    {/*</Label>*/}
                                </Form.Group>
                            </Form>
                        </Segment>
                    </Segment.Group>
                </React.Fragment>
            </div>
        );
    }

    renderHeadersDetails() {
        return (
            <div>
                <MIMEHeaderView vod header={false} streamid={this.props.streamId} streamName={this.props.streamName} url={this.props.url}/>
            </div>
        );
    }

    renderPlaylistDetails() {
        return (
            <div>
                <ManifestView vod header={false} streamid={this.props.streamId} streamName={this.props.streamName} url={this.props.url} sharedManifest={this.props.sharedManifest} streamType={this.props.streamType} masterFile={this.props.masterFile}/>
            </div>
        );
    }

    renderDownloadDetails() {
        return (
            <div>
                <MediaFileView
                    vod
                    header={false}
                    streamid={this.props.streamId}
                    streamName={this.props.streamName}
                    mode={this.props.mode}
                    audioEnabled={this.props.audioEnabled}
                    videoEnabled={this.props.videoEnabled}
                    pixelEnabled={this.props.pixelEnabled}
                />
            </div>
        );
    }

    renderTextTrackDetails() {
        return (
            <div>
                <TextView vod header={false} streamid={this.props.streamId} streamName={this.props.streamName} url={this.props.url}/>
            </div>
        );
    }

    renderAlarmLog() {
        return (
            <div>
                <AlarmLogView header={false} streamName={this.props.streamName}/>
            </div>
        );
    }

    renderTxnLog() {
        return (
            <div>
                <TransactionLogView header={false} streamName={this.props.streamName}/>
            </div>
        );
    }

    scheduleNextUpdate(ms ?: number) {
        if (this.updateTimer !== null) clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(() => this.fetchData(), ms);
    }

    fetchData() {
        // tslint:disable-next-line:no-console
        // console.log('FetchData...');
        this.state.tabIndex === 5 ? this.fetchAlarmLogData(true, this.props.streamName) : this.fetchAlarmLogData(false, this.props.streamName);
        this.state.tabIndex === 6 ? this.fetchTxnLogData(true, this.props.streamName) : this.fetchTxnLogData(false, this.props.streamName);
        // this.scheduleNextUpdate(30000);
    }

    renderAlarmLogDetailsErrors() {
        return (
            <div className="view-clientarea">
                <ReactTable
                    className="overflow-body transaction-log -striped -highlight"
                    // onFetchData={() => this.fetchData()}
                    data={(this.state && this.state.alarmLogData) || []}
                    columns={this.alarmColumnsErrors}
                    defaultPageSize={14}
                    pageSize={14}
                    PaginationComponent={CustomPagination}
                    noDataText={'No alarm logs for selected stream'}
                    defaultSorted={[
                        {
                            id: 'timestamp',
                            desc: true
                        }
                    ]}
                />
            </div>
        );
    }

    renderAlarmLogDetails() {
        return (
            <div className="view-clientarea">
                <ReactTable
                    className="overflow-body transaction-log -striped -highlight"
                    // onFetchData={() => this.fetchData()}
                    data={(this.state && this.state.alarmLogData) ? this.state.alarmLogData : []}
                    columns={this.alarmColumns}
                    defaultPageSize={14}
                    pageSize={14}
                    PaginationComponent={CustomPagination}
                    noDataText={'No alarm logs for selected stream'}
                    defaultSorted={[
                        {
                            id: 'timestamp',
                            desc: true
                        }
                    ]} // NOTE: A refresh causes it to collapse
                    SubComponent={(row: any) => {
                        let template = this.detailRenderer(row);
                        return (
                            <div>{template}</div>
                        );
                    }}
                />
            </div>
        );
    }

    renderTxnLogDetails() {
        return (
            <div className="view-clientarea">
                <ReactTable
                    className="overflow-body transaction-log -striped -highlight"
                    // onFetchData={() => this.fetchData()}
                    data={(this.state && this.state.txnLogData) || []}
                    columns={this.txnColumns}
                    defaultPageSize={14}
                    pageSize={14}
                    PaginationComponent={CustomPagination}
                    noDataText={'No transaction logs for selected stream'}
                    defaultSorted={[
                        {
                            id: 'timestamp',
                            desc: true
                        }
                    ]}
                />
            </div>
        );
    }

    fetchAlarmLogData(retrieveData: boolean, name: string) {
        let _this = this;
        let url = 'http://default/api/log/alarm?name=' + encodeURI(name);
        // let url = 'http://default/api/log/alarm';
        if (retrieveData) {
            axios.get(url)
                .then(function (response: AxiosResponse) {
                    if (response.data !== undefined) {
                        // tslint:disable-next-line:no-debugger
                        _this.setState({
                           alarmLogData: response.data.entries
                        });
                    } else
                        // tslint:disable-next-line:no-console
                        console.log('expected array of alarm logs, got ', response.data);
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('fetchAlarmLogData() error: ', error);
                });
        }
    }

    fetchTxnLogData(retrieveData: boolean, name: string) {
        let _this = this;
        let url = 'http://default/api/log/adp?name=' + encodeURI(name);
        if (retrieveData) {
            axios.get(url)
                .then(function (response: AxiosResponse) {
                    if (response.data !== undefined) {
                        // tslint:disable-next-line:no-debugger
                        _this.setState({
                           txnLogData: response.data.entries
                        });
                    } else
                        // tslint:disable-next-line:no-console
                        console.log('expected array of transaction logs, got ', response.data);
                })
                .catch(function (error: AxiosRequestConfig) {
                    // tslint:disable-next-line:no-console
                    console.log('fetchTxnLogData() error: ', error);
                });
        }
    }

    tooltipRenderer() {
        return <ReactTooltip effect="solid" place="top" html={true} delayShow={250} offset={{top: 70, left: 90}} className="tool-tip-override-general"/>;
    }

    tooltipRendererOrig(): React.ReactNode {
        return <ReactTooltip effect="float" place="top" html={true} delayShow={500} offset={{top: 10, left: 10}} className="tool-tip-override-general"/>;
    }

    mediaIpRenderer(value: any): React.ReactNode {
        return (
            <div data-tip={value}>
                {value}
            </div>
        );
    }

    rawRenderer(value: string) {
        if (value) {
            let length = value.split('_')[0].length;
            return value.split('_')[0].substring(1, length - 1);
        }
        return null;
    }

    txnDetailRenderer(value: any) {
        return (
            <div data-tip={value} className="text-wrap">
                {value}
            </div>);
    }

    detailRenderer(props: any) {
        let url = (props.original.detail.url ? props.original.detail.url.split('/') : null);
        let indexUrl = '';
        if (url != null) {
            url.splice(0, 1);
            indexUrl = url.toString().replace(/,/g, '/');
        }
        let currentValue = '';
        let threshold = '';
        let level = '';

        Object.keys(props.original.detail).forEach(key => {
            if (key.endsWith('cur')) {
                currentValue = props.original.detail[key];
            }
            if (key.endsWith('thr')) {
                threshold = props.original.detail[key];
            }
            if (key.endsWith('lvl') || key.endsWith('Lvl')) {
                level = props.original.detail[key];
            }
        });

        let streamType = (value: any, name: String) => value !== null ?  <td className="word-wrap" data-label={name} data-tip={value}>{value}</td> : null;
        return (
            <div className="template">
                <table className="table-large fixed-table">
                    <thead>
                    <tr>
                        <th>Asset</th>
                    </tr>
                    </thead>
                    <tbody>
                    {(props.original.detail && props.original.detail.conntimemax) &&
                    <tr>
                        {streamType(indexUrl !== '' ? indexUrl : null,  'Playlist: ')}
                        {streamType(props.original.detail.conntimemax, 'conntimemax')}
                        {streamType(props.original.detail.dnsTimeMax, 'dnsTimeMax')}
                    </tr>}
                    {(props.original.detail && props.original.detail.audiosilenchanactive) &&
                    <tr>
                        {streamType(indexUrl !== '' ? indexUrl : null,  'Playlist: ')}
                        {streamType(props.original.detail.audiosilenchanactive, 'Silence Channel Active')}
                        {streamType(props.original.detail.audiosilenchanalarm, 'Silence Channel Alarm Mask')}
                    </tr>}
                    <tr>
                        {streamType(indexUrl !== '' ? indexUrl : null,  'Playlist: ')}
                    </tr>
                    </tbody>
                </table>
                <table className="table-small">
                    <thead>
                    <tr>
                        <th>Alarm</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        {streamType(props.original.detail.flowFlt ? props.original.detail.flowFlt : null, 'Alarm Template')}
                        {streamType(props.original.detail.value >= 0 ? props.original.detail.value : null, 'Alarm Value')}
                        {streamType(props.original.detail.threshold >= 0 ? props.original.detail.threshold : null, 'Alarm Threshold')}
                        {streamType(currentValue === '' ? null : currentValue, 'Current Value')}
                        {streamType(threshold === '' ? null : threshold, 'Threshold')}
                        {streamType(level === '' ? null : level, 'Level')}
                    </tr>
                    </tbody>
                </table>
                {(!props.original.name && props.original.alarmName === 'LINK-UP') &&
                <table className="table-small">
                    <thead>
                    <tr>
                        <th>Detail</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        {streamType(props.original.detail ? this.rawRenderer(props.original.detail.raw) : null, '')}
                    </tr>
                    </tbody>
                </table>}
                {(!props.original.name && props.original.alarmName === 'SYS-OTGE') &&
                <table className="table-small">
                    <thead>
                    <tr>
                        <th>Detail</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        {streamType(props.original.detail && props.original.detail.totalSeconds ? props.original.detail.totalSeconds : null, 'Total Seconds')}
                        {streamType(props.original.detail && props.original.detail.streamcount ? props.original.detail.streamcount : null, 'Stream Count')}
                    </tr>
                    </tbody>
                </table>}
            </div>
        );
    }

    eventRenderer(props: any) {
        let clsName = 'eventType';

        if (props.original.type === 'info') {
            clsName = 'iq-td-status-info';
        }
        if (props.original.type === 'WARNING') {
            clsName = 'iq-td-alarm-major';
        } else
        if (props.original.type === 'ERROR') {
            clsName = 'iq-td-alarm-critical';
        }

        return (
            <div className={clsName} data-tip={props.value}>
                {props.value}
                {this.tooltipRenderer()}
            </div>);
    }

    nameRenderer(value: any) {
        return (
            <div data-tip={value}>
                {value}
            </div>);
    }

    severityRenderer(props: any): React.ReactNode {
        return (
            <div data-tip={props.value.toUpperCase()}>
                {props.value.toUpperCase()}
            </div>);
    }

    alarmNameRenderer(props: any): React.ReactNode {
        let longname = '';
        let clsName = 'eventType';

        if (props.value.startsWith('SYN-')) {
            props.value = props.value.slice(4);
        }
        switch (props.value) {
            case 'VIDO-NEW':
                longname = 'New Video Stream Detected';
                break;
            case 'VIDO-LOS':
                longname = 'Video Stream Outage';
                break;
            case 'LINK-UP':
                longname = 'LINK UP and Speed Change';
                break;
            case 'CONN-TIME':
                longname = 'Connection Time Error limit';
                break;
            case 'CONN-TIME-15':
                longname = 'Connection Time Error 15-Min Limit';
                break;
            case 'CONN-TIME-MAX':
                longname = 'Connection Time upper Limit Crossed';
                break;
            case 'DNS-TIME':
                longname = 'DNS Request Time Error limit';
                break;
            case 'DNS-TIME-15':
                longname = 'DNS Request Time Error 15-Min Limit';
                break;
            case 'DNS-TIME-MAX':
                longname = 'DNS Request Time Upper Limit Crossed';
                break;
            default:
                longname = props.value;
        }

        if (props.original.eventStatus === 'clear') {
            clsName = 'iq-td-status-clear';                     // clear is green
        } else if (props.value === 'OUTAGE') {
            clsName = 'iq-td-status-outage';                    // outage is black
        } else
        if (props.original.eventStatus === 'set') {
            if (props.original.severity === 'info') {
                clsName = 'iq-td-status-info';              // info is white
            }
            if (props.original.severity === 'warning') {
                clsName = 'iq-td-alarm-critical';           // All other alarms are red because SABR only has severity of outage alarms as 'critical'.
            } else                                              // But since outage alarms are black, we use red for others.
            if (props.original.severity === 'minor') {
                clsName = 'iq-td-alarm-critical';           // This is inconsistent from IVMS-AMS since they use red for critical and use orange for both major and minor.
            } else                                              // Inspector on the other hand has only green for clear and red for set.
            if (props.original.severity === 'major') {
                clsName = 'iq-td-alarm-critical';
            } else
            if (props.original.severity === 'critical') {
                clsName = 'iq-td-alarm-critical';
            }
        }
        return <div className={clsName} data-tip={longname}>{props.value}</div>;
    }

    hostUrlRenderer(props: any): React.ReactNode {
        let hostUrl = (props ? props.split('/') : null);

        return (
            <div data-tip={props ? hostUrl[0] : null}>
                {props ? hostUrl[0] : null}
            </div>
        );
    }

    replaceAll(str: string, find: string, replace: string) {
        return str.replace(new RegExp(find, 'g'), replace);
    }

    stateRenderer(result: string): React.ReactNode {
        let clsName = 'status-chicklet ';
        let message =  this.replaceAll(this.props.streamMessage.toString(), 'SYN-', '');

        switch (result) {
            case 'PASS': clsName += 'iq-td-status-clear'; break;      // Good        = Green
            case 'FAIL': clsName += 'iq-td-status-critical'; break;   // Fail        = Red
            case 'OUTAGE': clsName += 'iq-td-status-outage'; break;   // Outage      = Black
            default: clsName += 'iq-td-status-unknown'; break;        // Unknown     = Clear
        }

        return (
            <div data-tip={((result) ? result === 'PASS' ? 'Good' : result === 'FAIL' ? message : 'Outage' : 'Good' )}>
                <span className={clsName}/>
                {result === 'PASS' ? 'Good' : result === 'FAIL' ? 'Fail' : 'Outage'}
                {this.tooltipRenderer()}
            </div>
        );
    }

    renderTabs() {
        const panes = [
            { menuItem: 'Summary', render: this.renderSummaryDetails },
            { menuItem: 'Metrics', render: this.renderMetricsDetails },
            { menuItem: 'MIME Headers', render: this.renderHeadersDetails },
            { menuItem: 'Playlist', render: this.renderPlaylistDetails },
            { menuItem: 'Download Details', render: this.renderDownloadDetails },
            { menuItem: 'Alarm Log', render: this.renderAlarmLogDetailsErrors },
            { menuItem: 'Transaction Log', render: this.renderTxnLogDetails }
        ];

        if (this.state.showTabs) {
            return <Tab menu={{ secondary: true, pointing: true }} panes={panes} defaultActiveIndex={this.state.tabIndex} onTabChange={(event: any, data: any) => this.changeTab(data)}/>;
        } else {
            return 'Loading data ...';
        }
    }

    render() {
        return (
            <div className="view-content" id="test_details">
                {this.renderTabs()}
            </div>
        );
    }

    changeTab(data: any) {
        if (data.activeIndex === 0) {
            // tslint:disable-next-line:no-console
            console.log('Summary tab selected');
            // this.renderSummaryDetails();
        }  else if (data.activeIndex === 1) {
            // tslint:disable-next-line:no-console
            console.log('Metrics tab selected');
            // this.renderMetricsDetails();
        }  else if (data.activeIndex === 2) {
            // tslint:disable-next-line:no-console
            console.log('Headers tab selected');
            // this.renderHeadersDetails();
        }  else if (data.activeIndex === 3) {
            // tslint:disable-next-line:no-console
            console.log('Playlist tab selected');
            // this.renderPlaylistDetails();
        }  else if (data.activeIndex === 4) {
            // tslint:disable-next-line:no-console
            console.log('Download tab selected');
            // this.renderDownloadDetails();
        }  else if (data.activeIndex === 5) {
            // tslint:disable-next-line:no-console
            console.log('Alarms tab selected');
            // this.renderAlarmLogDetails();
        }  else if (data.activeIndex === 6) {
            // tslint:disable-next-line:no-console
            console.log('Txn tab selected');
            // this.renderTxnLogDetails();
        }
        this.setState({tabIndex: data.activeIndex});
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/monitoring/testDetails.tsx